import { changeCommaByPoint, changePointByComma } from "@/utils/common/change-point-by-comma";
import { formatDecimalNumbers } from "../format-decimal-numbers";

export const normalizePriceOfferToInternationalFormat = (price) => {
    let normalizedPrice = "";
    if (price && price !== '-') {
        const priceDecimalAsDot = changeCommaByPoint(price);
        if (typeof parseFloat(priceDecimalAsDot) === "number") {
            normalizedPrice = priceDecimalAsDot;
        }
    }
    return normalizedPrice;
}

export const parsePrice = (
    number,
    decimals = 2,
    decimalChar = ",",
    thousandChar = "."
) => {
    let res = number;
    if (res) {
        res = res.toString().replace(",", thousandChar);
        res = parseFloat(res).toFixed(decimals);
        res = res.replace(".", decimalChar);
        const splitNum = res.split(decimalChar);
        splitNum[0] = splitNum[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousandChar);
        if (splitNum[1] !== "00") {
            res = splitNum.join(decimalChar);
        } else {
            res = splitNum[0];
        }
    }
    return res;
}

export const calculateTotalAmountR2R = (monthlyPayment, quotas = 48) => {
    const parsedAmount = parseFloat(changeCommaByPoint(monthlyPayment));
    const totalAmount = formatDecimalNumbers(parsedAmount * quotas);
    return totalAmount;
}

export const calculateSavingR2R = ({ equivalentFreePriceBeforeDiscounts, totalAmount }) => {
    return Math.round(
        (equivalentFreePriceBeforeDiscounts) -
        totalAmount
    );
}